import React from 'react'
import Select from 'react-select'

const DEFAULT_MENU_PORTAL_Z_INDEX = 10050

export default ({
  styles: stylesProp,
  menuPortalTarget = typeof document !== 'undefined' ? document.body : null,
  ...rest
}) => (
  <Select
    placeholder="Selecionar"
    {...rest}
    menuPortalTarget={menuPortalTarget}
    menuPosition={rest.menuPosition || 'fixed'}
    styles={{
      ...stylesProp,
      menuPortal: (base, state) => {
        const custom = typeof stylesProp?.menuPortal === 'function'
          ? stylesProp.menuPortal(base, state)
          : { ...base, ...(stylesProp?.menuPortal || {}) }

        return {
          ...custom,
          zIndex: Math.max(Number(custom?.zIndex) || 0, DEFAULT_MENU_PORTAL_Z_INDEX),
        }
      },
    }}
  />
)
